<template>
<transition name="fade">
  <div class="comment-layer" ref="commentLayer" @click.self="$emit('close')">
    <div class="comment-error" :class="{'show-comment-error': commentError}">{{commentError}}</div>
    <div class="comment-form">
      <textarea ref="commentTextarea" :value="value" :placeholder="placeholder" @focus="handleFocus" @input="$emit('input', $event.target.value)" />
      <gkButton class="comment-btn" color="blue" size="big" :label="btnLabel" :disabled="!value" :use-lock="true" @click="submit" />
    </div>
  </div>
</transition>
</template>

<script>
import gkButton from 'gkui/button'

export default {
  name: 'comment-form',
  components: {
    gkButton
  },
  props: {
    /**
     * 输入框的值 通过 v-model 使用
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * 错误提示
     */
    commentError: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '写下你的想法，一起交流'
    },
    btnLabel: {
      type: String,
      default: '评论'
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // window.addEventListener('resize', this.resizeListener)
    this.$refs.commentTextarea.focus()
  },
  beforeDestroy () {
    // window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    handleFocus () {
      this.$emit('focus')
    },
    /**
     * 提交回复
     */
    submit ({clear}) {
      this.$emit('click', {clear})
      // this.$emit('close')
    },
    resizeListener () {
      this.$refs.commentLayer.style.bottom = '0'
      // this.$refs.commentLayer.style.position = 'absolute'
      // this.$refs.commentLayer.style.position = 'fixed'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.comment-layer {
  position: fixed; left: 0; bottom: 0; right: 0; z-index: 10;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  height: 100vh;
  background: transparent;

  & .comment-error {
    height: 20px;
    padding: 7px 20px 0;
    background: #F3F9FF;
    line-height: 20px;
    @include font(12, 400);
    color: $orange;
    transform: translateY(27px);
    @extend %transition;

    &.show-comment-error {
      transform: translateY(0);
    }
  }

  & .comment-form {
    position: relative; z-index: 1;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    width: 100%;
    padding: 7px 15px 7px 20px;
    // background: $lightGray;
    background: #F3F9FF;

    & textarea {
      flex: 1;
      display: block;
      height: 80px;
      padding: 4px 8px;
    }

    & .comment-btn {
      flex: 60px 0 0;
      margin: 0 0 0 8px;
    }
  }
}
</style>

 